import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-attraction-card',
  templateUrl: './attraction-card.component.html',
  styleUrls: ['./attraction-card.component.scss']
})
export class AttractionCardComponent implements OnInit {

  @Input() attraction: any;

  hover = false;

  constructor() { }

  onHover()
  {
    this.hover = !this.hover;
  }
  ngOnInit() {
  }

}
